import Resource from '@/api/resources/Resource'

class CommonUserServices extends Resource {
    async search(params) {
        const response = await this.axios.get('/common/users/search', { params })
        return response.data
    }
}

export default new CommonUserServices()
